
// src/web/components/login-page.jsx

import React from 'react'
import connect from '../../connects/login-page'
import { linkUI } from '../../helpers/form-validator'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import {
  List,
  ListItem,
} from 'react-toolbox/lib/list'
import {
  Card,
  CardTitle,
  CardText,
  CardActions,
} from 'react-toolbox/lib/card'
import {
  Input,
} from 'react-toolbox/lib/input'
import {
  Dialog,
} from 'react-toolbox/lib/dialog'
import theme from './themes/action-dialog.css'
import fluidInputTheme from './themes/fluid-input.css'
import ScrollableDialogPanel from './scrollable-dialog-panel.jsx'
import ConfirmDialog from './confirm-dialog.jsx'
import config from '../../config'
import appButtonTheme from './themes/app-button.css'
import loginPageTheme from './themes/login-page.css'

class LoginPage extends React.Component {
  state = {}
  toggleLoginHistoryDialog = ()=> this.setState({ loginHistoryDialog: !this.state.loginHistoryDialog })
  validateAndSubmit = (e)=> this.props.validateAndSubmit(this.props, e)
  clearLoginStatus = ()=> this.props.clearLoginStatus(this.props)
  onChangeEmail = linkUI(this, 'email')
  onChangePassword = linkUI(this, 'password')
  onChangePasscode = linkUI(this, 'passcode')
  onChangeNewPassword = linkUI(this, 'newPassword')
  onChangeNewPasswordConfirm = linkUI(this, 'newPasswordConfirm')

  setDocumentTitle = ()=> document.title = this.props.t('label:ログイン') + ' - gamba!'

  componentDidMount() {
    window.onSSOSuccess = (access_token)=> this.props.loadAccessToken(access_token)
    this.setDocumentTitle()
    zE(function(){ zE.show(); })
  }

  componentWillUnmount() {
    window.onSSOSuccess = undefined
    zE(function(){ zE.hide(); })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.sso_required && nextProps.sso_required && nextProps.sso_url)
      window.open(nextProps.sso_url, "gamba!", 'width=500,height=700,menubar=no,toolbar=no,location=no')
  }
  openSSOLogin = ()=> window.open(this.props.sso_url, "gamba!", 'width=500,height=700,menubar=no,toolbar=no,location=no')

  render() {
    const {
      t,
      ui,
      validateAndSubmit,
      trial_expired,
      re_trial,
      clearAlertMessage,
      isFailed,
      password_change_required,
      passcode_required,
      password_required,
      sso_required,
      sso_url,
      alertMessage,
    } = this.props

    return (
      <Card raised theme={loginPageTheme} className="login">
        <div className={loginPageTheme.gamba}>
          <h1>gamba!</h1>
        </div>

        <form onSubmit={this.validateAndSubmit}>
          <CardTitle title={t('message:ようこそ')} subtitle={t('message:ログインしてください')} />

          { !password_change_required && !passcode_required && !password_required && !sso_required &&
          <Card theme={loginPageTheme}>
            <div className={loginPageTheme.email}>
              <Input name="email" required
                theme={fluidInputTheme}
                autoFocus
                label={t('label:メールアドレス')}
                value={ui.email}
                icon='email'
                error={ui.emailError && t('error:メールアドレスを入力してください') || alertMessage}
                onChange={this.onChangeEmail} />
              {ui.history && ui.history.length > 0 &&
                <IconButton onClick={this.toggleLoginHistoryDialog} icon="arrow_drop_down" />
              }
            </div>
            <div style={{ height: '75px' }}></div>
            <CardActions theme={loginPageTheme}>
              <Button raised type="reset" label={t('label:取り消し')} onClick={this.clearLoginStatus} />
              <Button raised primary type="submit" icon="arrow_forward" label={t('label:次へ')} />
            </CardActions>
          </Card> }

          { sso_required &&
          <Card theme={loginPageTheme}>
            <Input name="email" disabled
                label={t('label:メールアドレス')}
                value={ui.email}
                icon='email' />
            <CardText>{t('label:シングルサインオン認証を行ってください')}</CardText>
            <CardActions theme={loginPageTheme}>
              <Button raised type="reset" label={t('label:取り消し')} onClick={this.clearLoginStatus} />
              <Button raised primary icon="arrow_forward" label={t('label:ログイン')} onClick={this.openSSOLogin} />
            </CardActions>
          </Card> }

          { password_required &&
          <Card theme={loginPageTheme}>
            <Input name="email" disabled
                label={t('label:メールアドレス')}
                value={ui.email}
                icon='email' />
            <Input name="password" required
              autoFocus
              type="password"
              label={t('label:パスワード')}
              icon='lock_open'
              value={ui.password}
              error={ui.passwordError && t('error:パスワードを入力してください') || alertMessage}
              onChange={this.onChangePassword} />
            <CardActions theme={loginPageTheme}>
              <Button raised type="reset" label={t('label:取り消し')} onClick={this.clearLoginStatus} />
              <Button raised primary type="submit" icon="done" label={t('label:ログイン')} />
            </CardActions>
          </Card> }

          { passcode_required &&
          <Card theme={loginPageTheme}>
            <Input name="email" disabled
                label={t('label:メールアドレス')}
                value={ui.email}
                icon='email' />
            <CardText>{t('label:確認コードについて')}</CardText>
            <Input name="passcode" required
              autoFocus
              label={t('label:確認コード')}
              icon='phonelink_lock'
              value={ui.passcode}
              error={ui.passcodeError && t('error:確認コードを入力してください')}
              onChange={this.onChangePasscode} />
            <Input name="password" required
              type="password"
              label={t('label:パスワード')}
              icon='lock_open'
              value={ui.password}
              error={ui.passwordError && t('error:パスワードを入力してください') || alertMessage}
              onChange={this.onChangePassword} />
            <CardActions theme={loginPageTheme}>
              <Button raised type="reset" label={t('label:取り消し')} onClick={this.clearLoginStatus} />
              <Button raised primary type="submit" icon="done" label={t('label:ログイン')} />
            </CardActions>
          </Card> }

          { password_change_required &&
          <Card theme={loginPageTheme}>
            <Input name="email" disabled
                label={t('label:メールアドレス')}
                value={ui.email}
                icon='email' />
            <CardText>{t('label:パスワードの変更が必要です')}</CardText>
            <Input name="oldPassword"
              type="password"
              autoFocus
              label={t('label:現在のパスワード')}
              value={ui.password}
              icon='lock_open'
              error={ui.passwordError && t('error:パスワードを入力してください')}
              onChange={this.onChangePassword} />
            <Input name="password"
              type="password"
              label={t('label:新しいパスワード')}
              value={ui.newPassword}
              icon='lock_open'
              error={ui.newPasswordError && t('error:パスワードを入力してください')}
              onChange={this.onChangeNewPassword} />
            <Input name="passwordConfirm"
              type="password"
              label={t('label:新しいパスワード(再入力)')}
              value={ui.newPasswordConfirm}
              icon='lock_open'
              error={ui.newPasswordConfirmError && t('error:パスワードを入力してください') || alertMessage}
              onChange={this.onChangeNewPasswordConfirm} />
            <CardActions theme={loginPageTheme}>
              <Button raised type="reset" label={t('label:取り消し')} onClick={this.clearLoginStatus} />
              <Button raised primary type="submit" icon="done" label={t('label:パスワードを変更してログイン')} />
            </CardActions>
          </Card> }

          <CardText style={{ alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
            <div><a href={config.baseUrl+"v3/registration/password_reset"} target="_blank" rel="noopener noreferrer">{t('label:パスワード再発行')}</a></div>
            <div><a href={t('url:無料体験リンク')} target="_blank" rel="noopener noreferrer">{t('label:無料体験に登録')}</a></div>
            <div><a href={t('url:gambaにログインできない')} target="_blank" rel="noopener noreferrer">{t('label:うまくログインできない時')}</a></div>
            <div><a href="https://www.getgamba.com/" target="_blank" rel="noopener noreferrer">{t('label:gambaについて')}</a></div>
          </CardText>

          <div style={{ margin: '0 40px' }}>{t('label:アプリもあります')}</div>
          <div style={{ margin: '20px 10px', display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
            <a href="https://itunes.apple.com/jp/app/gamba-ri-bao-gong-younotameno/id1032574463?mt=8" target="_blank" rel="noopener noreferrer">
              <span className={appButtonTheme.itunes} />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.rikkeisoft.gamba" target="_blank" rel="noopener noreferrer">
              <span className={appButtonTheme.android} />
            </a>
          </div>
        </form>

        <ConfirmDialog open={trial_expired} centeredTitle
          title={t('label:トライアル期間が終了しました')}
          description={t('label:引き続き利用するには契約が必要です')}
          yesLabel={t('label:契約する')}
          noLabel={t('label:閉じる')}
          yesHref={`${config.baseUrl}v3/contract`}
          onNo={clearAlertMessage} />

        <ConfirmDialog open={re_trial} reTrialMessage centeredTitle
          configBaseUrl={config.baseUrl}
          title={t('label:お客様のトライアル期間は終了しました')}
          description={t('label:再度利用するにはもう一度トライアルをしてください')}
          yesLabel={t('label:無料トライアルを始める')}
          noLabel={t('label:閉じる')}
          yesHref={`${config.baseUrl}v3/registration/new_refresh?email=${encodeURIComponent(ui.email)}`}
          onNo={clearAlertMessage} />

        {ui.history && ui.history.length > 0 &&
          <Dialog active={!!this.state.loginHistoryDialog} theme={theme}
            title={t('label:メールアドレスを選択')}
            actions={[
              { raised: true, label: t('label:取り消し'), onClick: this.toggleLoginHistoryDialog }
            ]}
            onOverlayClick={this.toggleLoginHistoryDialog}
            onEscKeyDown={this.toggleLoginHistoryDialog} >
            <ScrollableDialogPanel>
              <List>
              {ui.history && _.map(ui.history, (item, i)=> 
                <ListItem caption={item.email} selectable key={i}
                  onClick={()=> { this.toggleLoginHistoryDialog();  this.onChangeEmail(item.email) }} />
              )}
              </List>
            </ScrollableDialogPanel>
          </Dialog>
        }
      </Card>
    )
  }
}

export const RawLoginPage = LoginPage
export default connect(LoginPage)



// WEBPACK FOOTER //
// ./src/web/components/login-page.jsx